import { motion } from "framer-motion";
import { Feather } from "lucide-react";

const ENTRIES = [
  {
    numeral: "XLII",
    title: "The Merchant of Jaipur",
    moon: "Written on the third night of the waxing moon",
    text: "My shop stood silent for two years. After the prosperity working, orders arrived as if the rivers themselves had changed course. I do not pretend to understand the stars — I only know my ledgers are full.",
    sign: "R. Sharma · Wealth Working",
  },
  {
    numeral: "XVII",
    title: "The Wife of Devon",
    moon: "Recorded beneath a full harvest moon",
    text: "Fifteen years of marriage had cooled to silence. The harmonising seals were cast with such care, such reverence. Within a season we were speaking again — truly speaking — for the first time in a decade.",
    sign: "E. Whitmore · Marriage Restoration",
  },
  {
    numeral: "CVIII",
    title: "The Clerk Who Would Rise",
    moon: "Inked at dawn, Mercury in ascension",
    text: "Passed over for promotion four times. The Solomonic favor working was performed on the correct planetary hour, and within two moons I sat in the office I had long been denied. Coincidence, perhaps. I choose to believe otherwise.",
    sign: "D. Okafor · Career Arcana",
  },
  {
    numeral: "IX",
    title: "The Disputed Acre",
    moon: "Sealed as the moon turned to waning",
    text: "A boundary quarrel that poisoned two families for a generation ended in a single season after the warding rite. The surveyor's report came back in our favor; the neighbors now wave when they pass.",
    sign: "M. & T. Alvarez · Property Warding",
  },
];

export const Testimonials = () => (
  <section
    id="testimonials"
    data-testid="testimonials-section"
    className="relative py-28 sm:py-36"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-16 text-center"
      >
        <p className="text-xs uppercase tracking-[0.35em] text-gold/80 font-mono mb-4">
          The Book of Whispers
        </p>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight text-parchment max-w-2xl mx-auto">
          Words left by seekers, copied faithfully into our journal
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {ENTRIES.map((e, i) => (
          <motion.article
            key={e.numeral}
            data-testid={`testimonial-card-${e.numeral.toLowerCase()}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 2) * 0.15 }}
            className="parchment-card relative rounded-xl p-9 sm:p-11 card-glow transition-shadow duration-500"
          >
            <Feather className="absolute top-7 right-8 text-gold/25" size={26} strokeWidth={1.25} />
            <p className="text-[10px] uppercase tracking-[0.35em] font-mono text-gold/70 mb-1">
              Entry {e.numeral}
            </p>
            <h3 className="font-serif text-xl sm:text-2xl text-gold mb-1.5">{e.title}</h3>
            <p className="font-quote italic text-xs text-parchment-muted mb-6">{e.moon}</p>
            <p className="font-quote text-lg sm:text-xl text-parchment/90 leading-relaxed mb-7">
              <span className="font-display text-3xl text-gold float-left mr-2 leading-[0.85] mt-1">
                {e.text.charAt(0)}
              </span>
              {e.text.slice(1)}
            </p>
            <footer className="text-xs uppercase tracking-[0.2em] text-parchment-muted">
              — {e.sign}
            </footer>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
